import React, { memo } from "react";
import { RiCommandFill } from "react-icons/ri";
import Button from "../../../theme/button/Button";
import { useKeyboardState } from "../../../../contexts/KeyboardShortcutContext";

function ShortcutsWidget({ metricPathPrefix }: { metricPathPrefix: string[] }) {
    const keyboard = useKeyboardState();

    return (
        <Button
            size="small"
            variant="ghost-gray"
            prefixIcon={<RiCommandFill />}
            metricPath={[...metricPathPrefix, "shortcuts"]}
            onClick={() => keyboard.toggleShortcutsMenu()}
        />
    );
}

export default memo(ShortcutsWidget);
